// src/fleet-stats/utils/audience.js
//
// Classifies every client/site into an audience so the fleet story can be told
// per business relationship:
//   customer — paying customer sites (the default fleet view)
//   partner  — company partners running our robots (not working customer sites)
//   internal — our own demo/test/production sites
//
// Every audience is selectable in the FleetStats view lens, including "All",
// which shows the three together. "customer" stays the default so the fleet
// story opens on paying customers rather than on our own test robots.
//
// EDIT THE MAP BELOW to reclassify a client. Site names matching /internal/
// are always internal regardless of client.

export const CLIENT_AUDIENCE = {
    partner: "partner",     // the shared partner account (Adaptiv, Rth, Rackart, …)
    beewatec: "partner",    // its only site is "Partner"
    wheelme: "internal",    // Demo, Production
    fredrikstad: "internal", // our warehouse: robots are built and tested here,
                             // so every unit passes through it before shipping
};

export const AUDIENCE_OPTIONS = [
    { key: "customer", label: "Customers", hint: "Paying customer sites" },
    { key: "partner", label: "Partners", hint: "Company partner accounts (partner, beewatec)" },
    { key: "internal", label: "Internal", hint: "Our own demo, test and production sites" },
    { key: "all", label: "All", hint: "Customers, partners and internal sites together" },
];

export function classifyAudience(client, siteName) {
    if (/internal/i.test(siteName || "")) return "internal";
    return CLIENT_AUDIENCE[(client || "").toLowerCase()] || "customer";
}
